import attacks from '@/game/attacks.js'
// import attackEffects from '@/game/attack-effects.js'

export default class BattleScene {
  constructor (player, enemy, onEmit) {
    this.turn = 0
    this.level = 0
    this.onEmit = onEmit
    this.numPlayers = 2
    this.attackQueue = {}
    this.combatants = {
      0: {
        health: 20,
        status: undefined,
        character: player,
        combos: {
          reduceDamage: 0
        }
      },
      1: {
        health: 20,
        status: undefined,
        character: enemy,
        combos: {
          reduceDamage: 0
        }
      }
    }
  }

  get player () {
    return this.combatants['0']
  }

  get enemy () {
    return this.combatants['1']
  }

  get state () {
    return JSON.parse(JSON.stringify(this.combatants))
  }

  emit (name, payload) {
    this.onEmit({ name, payload })
  }

  sendAction (playerId, attackIndex) {
    const { attackQueue, numPlayers } = this

    attackQueue[playerId] = attackIndex

    if (Object.keys(attackQueue).length === numPlayers) {
      this.resolveAttackQueue()
    }
  }

  resolveAttackQueue () {
    let actions = []

    let attackers = [ this.player, this.enemy ]
    let result, attacker, defender

    // Choose first attacker
    // TODO: effects
    attacker = attackers.splice(Math.round(Math.random()), 1)[0]
    defender = attackers[0]

    // First attacker
    result  = this.resolveAttack(attacker, defender)
    actions = [ ...actions, ...result.actions ]

    // Second attacker
    if (!result.winner) {
      result  = this.resolveAttack(defender, attacker)
      actions = [ ...actions, ...result.actions ]
    }

    this.emit('ATTACK_QUEUE_RESOLVED', actions)

    this.attackQueue = {}
  }

  resolveAttack (attacker, defender) {
    let winner = undefined
    const actions = []

    const character = attacker.character
    const defenderChar = defender.character

    const attackIndex = this.attackQueue[character.id]
    const attack = attacks[character.attacks[attackIndex]]

    // Damage

    const accuracy = attack.accuracy - 0.1
    if (Math.random() > accuracy) {
      actions.push({
        name: attack.accuracy === 1 ? 'EVADED' : 'MISSED',
        state: this.state,
        attack: character.attacks[attackIndex],
        attacker: character.id,
        defender: defenderChar.id
      })
    } else {
      let damage = 20 * attack.power

      defender.health -= damage

      actions.push({
        name: 'DAMAGE_DONE',
        state: this.state,
        damage,
        attack: character.attacks[attackIndex],
        attacker: character.id,
        defender: defenderChar.id
      })
    }

    // Statuses

    // TODO

    // Effects

    // TODO

    // Defeat

    if (defender.health <= 0) {
      winner = attacker.character.id
      actions.push({
        name: 'CHARACTER_DEFEATED',
        state: this.state,
        loser: defender.character.id
      })
    }

    return {
      winner,
      actions
    }
  }
}
